import React, { useState } from "react";
import axios from "axios";


const useStaffStatisticsDepartment = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const [data, setData] = useState([])
    const getStaffStatisticsDepartmentData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get('/organization_structure/api/staff/statistics_department', {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data)
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    const postStaffStatisticsDepartmentData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post('/organization_structure/api/staff/statistics_department',
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    const patchStaffStatisticsDepartmentData = (data) => {
        onBefore({
            axiosMode: "patch"
        })
        axios.patch('/organization_structure/api/staff/statistics_department',
                data
            
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "patch",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "patch",
                        status: "error"
                    }
                )
            })
    }
    const deleteStaffStatisticsDepartmentData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete('/organization_structure/api/staff/statistics_department',
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "fail") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })
    }
    return {
        StaffStatisticsDepartmentData: data,
        getStaffStatisticsDepartmentData,
        postStaffStatisticsDepartmentData,
        patchStaffStatisticsDepartmentData,
        deleteStaffStatisticsDepartmentData,
    }
}
export { useStaffStatisticsDepartment }
